export const LoadingButton = () => {
  return <button className="btn btn-primary" disabled>
    <span className="spinner-border spinner-border-sm"></span>
    Loading..
  </button>
};
